﻿import "../crypto/extensions";
import { isDomainTextValid } from '../utils/domainHelper';
import * as certificates from '../crypto/certificates';
import { buildFetchUrl } from "../utils/toolHelper";

interface CertificateResult { certificate: string, chain: string, thumbprint: string }

var DOMAIN_TO_ISSUE_QUERY_PARAM = "domainToIssue";
var domainToIssue: string;
var redirectUrl: string;
var certkitGuid: string;
var privateKey: string;
var email: string;
var certificateResult: CertificateResult;
var domainContainer = document.getElementById("domain-container") as HTMLDivElement;
var redirectContainer = document.getElementById("redirect-container") as HTMLDivElement;
var certContainer = document.getElementById("cert-container") as HTMLDivElement;
var errorContainer = document.getElementById("error-container") as HTMLDivElement;
var certIssuing = document.getElementById("cert-issuing") as HTMLDivElement;
var certEmail = document.getElementById("cert-email") as HTMLDivElement;
var certIssued = document.getElementById("cert-issued") as HTMLDivElement;
var checkProgress = document.getElementById("check-progress") as HTMLDivElement;
var commonWebservers = document.getElementById("common-webservers") as HTMLDivElement;
var domainIssued = document.getElementById("domain-issued") as HTMLHeadingElement;
var domainText = document.getElementById("domain-text") as HTMLInputElement;
var emailText = document.getElementById("email-text") as HTMLInputElement;
var generateButton = document.getElementById("generate-cert") as HTMLButtonElement;
var issueCertButton = document.getElementById("issue-cert") as HTMLButtonElement;
var iDidThisButton = document.querySelector(".i-did-this") as HTMLButtonElement;
var downloadPrivateKeyButton = document.getElementById("download-key") as HTMLButtonElement;
var downloadCertificateButton = document.getElementById("download-cert") as HTMLButtonElement;

var privateKeyText = document.getElementById("private-key-text") as HTMLTextAreaElement;
var certText = document.getElementById("certificate-text") as HTMLTextAreaElement;
var lastChecked = document.getElementById("last-checked") as HTMLParagraphElement;
var lastStatus = document.getElementById("last-status") as HTMLParagraphElement;
var errorMessage = document.getElementById("error-message") as HTMLHeadElement;

domainText.addEventListener("keyup", (evt) => {
    if (isDomainTextValid(domainText.value)) {
        generateButton.disabled = false;
        if (evt.keyCode == 13) {
            generateButtonClicked();
        }
    }
    else {
        generateButton.disabled = true;
    }
});

var generateButtonClicked = async () => {
    domainToIssue = domainText.value as string;

    try {

        await getChallengeGuid();

        await redirectSetup();

        await pollForRedirect();

        email = await getEmail();

        certificateResult = await generateCsrAndIssueCert();
    }
    catch (ex) {
        errorContainer.style.display = "block";
        errorMessage.innerText = ex.toString();
    }
}

generateButton.addEventListener("click", generateButtonClicked)


async function getChallengeGuid() {
    var response = await fetch(buildFetchUrl("?handler=BeginCertificate"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            domain: domainToIssue
        })
    });

    var json = await response.json();

    if (json.error) {
        throw new Error(json.error);
    }

    domainContainer.style.display = "none";
    redirectContainer.style.display = "block";
    try {
        const url = new URL(window.location.toString());
        url.searchParams.set(DOMAIN_TO_ISSUE_QUERY_PARAM, domainToIssue);
        history.replaceState(null, "", url);
    }
    catch { }

    certkitGuid = json.challengeGuid;
    redirectUrl = json.httpRedirectUrl;

    Array.from(document.querySelectorAll<HTMLSpanElement>(".domain-to-issue")).forEach(x => {
        x.innerText = domainToIssue;
    });

    Array.from(document.querySelectorAll<HTMLSpanElement>(".redirect-url")).forEach(x => {
        x.innerText = redirectUrl;
    });

}

async function redirectSetup(): Promise<void> {
    const deferred = (() => {
        let resolve, reject;
        const promise = new Promise<void>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    })();

    iDidThisButton.addEventListener("click", () => {
        deferred.resolve();
    });


    return deferred.promise;
}

async function pollForRedirect() {

    commonWebservers.style.display = "none";
    checkProgress.style.display = "block";

    var doPoll = async (): Promise<{ isConfigured: boolean, statusMessage: string }> => {
        var response = await fetch(buildFetchUrl("?handler=CheckHttpRedirect"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                domain: domainToIssue
            })
        })

        var json = await response.json();

        return json;
    }

    var isConfigured = false;
    var timesChecked = 1;
    await new Promise(r => setTimeout(r, 1500));
    do {
        var json = await doPoll();
        isConfigured = json.isConfigured;
        lastChecked.innerHTML = "Last Checked: " + new Date().toLocaleTimeString() + ` (Checked ${timesChecked.toLocaleString()} times)`
        timesChecked++;
        lastStatus.innerHTML = "Last Status: " + json.statusMessage;
        console.log("REDIRECT", isConfigured);
        if (!isConfigured) {
            await new Promise(r => setTimeout(r, 5000));
        }
    }
    while (isConfigured == false);


    return;
}

async function issueCertificate(domainToIssue: string, stuff: { csr: string; publicKey: string; privateKey: string; }): Promise<CertificateResult> {
    try {
        const url = new URL(window.location.toString());
        url.searchParams.delete(DOMAIN_TO_ISSUE_QUERY_PARAM)
        history.replaceState(null, "", url);
    }
    catch { }

    privateKey = stuff.privateKey;

    var response = await fetch(buildFetchUrl("?handler=IssueCertificate"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            domain: domainToIssue,
            csr: stuff.csr,
            email: email
        }),
    })

    if (response.status != 200) {
        throw new Error(await response.text());
    }

    var json = await response.json();

    return json;
}

async function getEmail(): Promise<string> {
    redirectContainer.style.display = "none";
    certEmail.style.display = "block";
    const deferred = (() => {
        let resolve, reject;
        const promise = new Promise<string>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    })();

    emailText.addEventListener("keyup", (evt) => {
        var isValid = emailText.checkValidity()
        issueCertButton.disabled = !isValid;
        if (evt.keyCode == 13 && isValid) {
            deferred.resolve(emailText.value);
        }
    });

    issueCertButton.addEventListener("click", () => {
        deferred.resolve(emailText.value);
    })

    return deferred.promise;
}


async function generateCsrAndIssueCert() {
    certContainer.style.display = "block";
    certIssuing.style.display = "block";
    certEmail.style.display = "none";

    var csrData = await certificates.generateCsr(domainToIssue);

    var certificateResult = await issueCertificate(domainToIssue, csrData);

    certIssuing.style.display = "none";
    certIssued.style.display = "block";

    domainIssued.innerText = domainToIssue;
    privateKeyText.value = privateKey;
    certText.value = certificateResult.certificate + "\n" + certificateResult.chain;

    return certificateResult;
}

downloadCertificateButton.addEventListener("click", () => {
    var text = certificateResult.certificate + "\n" + certificateResult.chain;
    var file = new File([text], "certificate.pem");
    var downloadUrl = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'certificate.pem'; // The desired filename for the JS file

    document.body.appendChild(link); // Append to DOM to make it clickable
    link.click(); // Programmatically click the link to trigger download
    setTimeout(() => {
        document.body.removeChild(link); // Clean up the DOM
        URL.revokeObjectURL(downloadUrl); // Release the object URL
    }, 100);
})

downloadPrivateKeyButton.addEventListener("click", () => {
    var text = privateKey;
    var file = new File([text], "private.key");
    var downloadUrl = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = "private.key"; // The desired filename for the JS file

    document.body.appendChild(link); // Append to DOM to make it clickable
    link.click(); // Programmatically click the link to trigger download
    setTimeout(() => {
        document.body.removeChild(link); // Clean up the DOM
        URL.revokeObjectURL(downloadUrl); // Release the object URL
    }, 100);
})
///

function animateLoading() {
    const frames = ['-', '\\', '|', '/'];
    var loadingElements = document.querySelectorAll<HTMLDivElement>(".loading");

    loadingElements.forEach(el => {
        let i = 0;
        const spinner = setInterval(() => {
            el.innerText = frames[i = ++i % frames.length];
        }, 125);
    })
}

try {
    const url = new URL(window.location.toString());
    var prevDomain = url.searchParams.get(DOMAIN_TO_ISSUE_QUERY_PARAM);
    if (prevDomain) {
        domainText.value = prevDomain;
        generateButtonClicked();
    }
}
catch { }

animateLoading();


